import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {},
  reducers: {
    openDashboard(state) {
      // Reducer logic for opening the dashboard
    },
    startAssessment(state, action: PayloadAction<boolean>) {
      // Reducer logic for starting the assessment
    },
    skipAssessment(state, action: PayloadAction<boolean | undefined>) {
      // Reducer logic for skipping the assessment
    },
    saveMood(state, action: PayloadAction<number>) {
      // Reducer logic for saving the mood
    },
    subscribeToNewsletter(state) {
      // Reducer logic for subscribing to the newsletter
    },
  },
});

export const DashboardActions = dashboardSlice.actions;
export default dashboardSlice.reducer;
